const aaa = [

    {
		path: "medical",
		component: () => import("@/views/chanpin/medical/medical.vue"),
		meta:{title:'药品'},
	},
	{
		path: "addmedical",
		component: () => import("@/views/chanpin/medical/addmedical.vue"),
		meta:{title:'编辑药品'},
	},
	
]
export default aaa;